export default __webpack_public_path__ + "static/media/heart.1406d486.svg";